<div class="modal-all">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ "detail_service.modals.modal-gestion-node.title" | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      [attr.aria-label]="
        'detail_service.modals.modal-gestion-node.ariaClose' | translate
      "
      (click)="closeCanvas()"
    >
      <span aria-hidden="true" class="visually-hidden"> &times; </span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="assignForm" class="d-flex flex-column gap-4">
      <div class="form-group">
        <label class="label_form">
          {{ "detail_service.modals.modal-gestion-node.labelDate" | translate }}
        </label>
        <input
          type="date"
          formControlName="nodeDate"
          class="form-control"
          id="myDatePicker"
        />
      </div>

      <div class="row">
        <div class="col">
          <label class="label_form">
            {{
              "detail_service.modals.modal-gestion-node.labelStartTime"
                | translate
            }}
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="nodeStartHour"
            placeholder="HH:mm"
            inputmode="numeric"
            pattern="^([01]\d|2[0-3]):([0-5]\d)$"
            maxlength="5"
            (input)="formatHour('nodeStartHour')"
          />
        </div>
        <div class="col">
          <label class="label_form">
            {{
              "detail_service.modals.modal-gestion-node.labelEndTime"
                | translate
            }}
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="nodeEndHour"
            placeholder="HH:mm"
            inputmode="numeric"
            pattern="^([01]\d|2[0-3]):([0-5]\d)$"
            maxlength="5"
            (input)="formatHour('nodeEndHour')"
          />
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button
      class="cancel-button"
      tuiButton
      appearance="secondary"
      type="button"
      (click)="closeCanvas()"
    >
      {{ "detail_service.modals.modal-gestion-node.buttonDiscard" | translate }}
    </button>

    <button
      tuiButton
      appearance="primary-button"
      type="submit"
      class="confirm-button"
      (click)="editNodeDateTime()"
      [disabled]="assignForm.invalid || loading"
    >
      <ng-container *ngIf="loading; else notLoading">
        <tui-loader size="s"></tui-loader>
      </ng-container>

      <ng-template #notLoading>
        {{ "detail_service.modals.modal-gestion-node.buttonEdit" | translate }}
      </ng-template>
    </button>
  </div>
</div>
